import { fetchCustomerApi, updateCustomerApi } from './api'

export const SET_CUSTOMER = 'SET_CUSTOMER';
export const UPDATING_CUSTOMER = 'UPDATING_CUSTOMER';
export const REQUEST_CUSTOMER = 'REQUEST_CUSTOMER';
export const RESET_CUSTOMER = 'RESET_CUSTOMER';

function setCustomer(customer) {
  return {
    type: SET_CUSTOMER,
    customer: customer
  };
}

function updatingCustomer() {
   return {
    type: UPDATING_CUSTOMER,
  };
}

function requestCustomer() {
   return {
    type: REQUEST_CUSTOMER,
  };
}

export function fetchCustomer(shipback_id, user_token) {
  return function (dispatch) {
    dispatch(requestCustomer())
    return fetchCustomerApi(shipback_id, user_token)
    .then(json =>
      {
        if (json.locale == undefined || json.locale != locale) {
          dispatch(updateCustomer({locale: locale} , shipback_id, user_token))
        } else {
          dispatch(setCustomer(json))
        }
      })
  }
}

export function updateCustomer(customer, shipback_id, user_token) {
  return function (dispatch) {
    dispatch(updatingCustomer())
    return updateCustomerApi(customer, shipback_id, user_token)
    .then(json => {
      if (!json.errors) {
        dispatch(setCustomer(json))
      } else {
        dispatch({
          type: RESET_CUSTOMER
        })
      }
    })
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/actions/customer.js